// extracted by mini-css-extract-plugin
export var colorBase = "vUp4oS87erjG6zxdEY9A";
export var colorDisabled = "YW_XTWIfb713z_BeuIyW";
export var colorInverted = "AK_9ftKPKtagaTUN5tUV";
export var colorNegative = "tbSkpSE1QG914dnnSFEu";
export var colorPositive = "e2UhGOdYz8dQv5PzzsZB";
export var colorSubdued = "yNejzlKAVdiN5gjax7zI";
export var colorSubtle = "eLtxykSq5jRxiDyK7S_d";
export var colorUrgencyHigh = "gtpD1w0rv8umfP2UVIkF";
export var colorUrgencyMedium = "UjYISVm7LH6WEYKtnfig";
export var colorWarning = "UURSYbQASYAtVNF88ZAU";
export var colorWhite = "O6USwO6PSyaA_fqqVjfa";